export interface WordForms {
  one: string;
  few: string;
  many: string;
}

export const pluralizePhrase = (count: number, forms: WordForms) => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return forms.many;
  }

  if (lastDigit === 1) {
    return forms.one;
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return forms.few;
  }

  return forms.many;
};
